import { Plus } from "lucide-react";
import type { ReactNode } from "react";

/**
 * Inline chip used next to a guest's name during inline edit to add or
 * remove a feature flag (pet-friendly, accessibility). Shared by the
 * reservation and waitlist detail panels so both lists read identically.
 */
export function FeatureToggleChip({
  selected,
  onClick,
  label,
  icon,
}: {
  selected: boolean;
  onClick: () => void;
  label: string;
  icon: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={selected ? `Quitar ${label.toLowerCase()}` : `Agregar ${label.toLowerCase()}`}
      aria-pressed={selected}
      className={
        "inline-flex h-5 items-center justify-center rounded text-text-secondary transition-colors " +
        (selected
          ? "w-5 border border-[#c8c8c2] bg-[#f7f6f3] hover:bg-[#ececea]"
          : "gap-0.5 border border-dashed border-text-secondary/60 bg-white px-1 hover:bg-[#f7f6f3]")
      }
    >
      {!selected && <Plus className="size-2.5" aria-hidden="true" />}
      {icon}
    </button>
  );
}
